import { openModal } from '@core/components/ModalStack';
import { ViewProposalModalProps } from './ViewProposalModal';

export async function openViewProposal(props: ViewProposalModalProps) {
  const { ViewProposalModal } = await import('./ViewProposalModal');

  openModal(ViewProposalModal, props);
}
